import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, NEVER, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { JobProcedureFormDetailsResponse } from '../models/procedure-copilot-confirmation-details.model';
import {JobProcedureService} from "../services/sections/job/job-procedure.service";

@Injectable({
	providedIn: 'root'
})
export class ProcedureStepFormDetailsResolver implements Resolve<JobProcedureFormDetailsResponse> {
	constructor(
		private router: Router,
		private procedureService: JobProcedureService
	) {}

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JobProcedureFormDetailsResponse> {
		const jobProcedureFormId = Number(activatedRouteSnapshot.paramMap.get('jobProcedureFormId'));
		const token = activatedRouteSnapshot.paramMap.get('token');
		const isFromSummaryReview = state.url.includes('procedure-summary-review');

		if (!token) {
			this.router.navigate(['/404']);
			return NEVER;
		}

		if (!jobProcedureFormId || isNaN(jobProcedureFormId)) {
			this.router.navigate(['/404']);
			return NEVER;
		}

		const stepPhotos$ = isFromSummaryReview ? this.procedureService.stepPhotosV3(token!, jobProcedureFormId) : this.procedureService.stepPhotosV2(token!, jobProcedureFormId);
		const stepResult$ = isFromSummaryReview ? this.procedureService.stepResultV3(token!, jobProcedureFormId) : this.procedureService.stepResultV2(token!, jobProcedureFormId);
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return forkJoin([
			stepPhotos$,
			stepResult$
		]).pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				map(([photos, formResult]) => ({
					stepPhotos: photos,
					stepResult: {
						formTemplateId: formResult.formTemplateId,
						formName: formResult.formName,
						defaultUISchema: formResult.defaultUiSchema,
						defaultUISchemaObj: JSON.parse(formResult.defaultUiSchema),          
						formData: formResult.formData,         
						formDataObj: JSON.parse(formResult.formData),
						jsonSchema: formResult.jsonSchema,
						jsonSchemaObj: JSON.parse(formResult.jsonSchema),

						collectedBy: undefined,
						collectedOn: undefined,
						jobSourcingTierId: undefined,         
						jobFormResultId: undefined,
						jobResourceId: undefined,  
					}
				}))
		);
	}
}
